/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const HierarchyChangeIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    onClick={props.onClick}
  >
    <g>
      <circle cx="11.5" cy="3.001" r="2.5" />
      <circle cx="11.5" cy="21.001" r="2.5" />
      <circle cx="20" cy="21.001" r="2.5" />
      <circle cx="20" cy="21" r="1" />
      <circle cx="3" cy="21.001" r="2.5" />
      <path d="M11.5,5.501 L11.5,18.501" />
      <path d="M3,18.501 C3,15.187 5.187,12.501 8.5,12.501 L14,12.501 C17.314,12.501 20,15.187 20,18.501" />
    </g>
  </svg>
);

export default HierarchyChangeIcon;
